import { createContext } from 'use-context-selector';

import type { EditEnrichedVacancyContextState } from './EditEnrichedVacancyContext.types';

import { notImplemented } from 'utils/notImplemented';

export const editEnrichedVacancyContextInitialData: EditEnrichedVacancyContextState = {
  enrichedVersion: { ref: { current: null }, initialData: null, hasErrors: false },
  jobPreview: { ref: { current: null }, initialData: null },

  setEnrichedVersionInitialData: notImplemented,
  setJobPreviewInitialData: notImplemented,
  setEnrichedVersionHasErrors: notImplemented,
};

export const EditEnrichedVacancyContext = createContext(editEnrichedVacancyContextInitialData);
